// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ba9329a8","501":"030d2bdd","646":"ca7b71cc","727":"382ed90b"}[chunkId] + ".chunk.js";
};